import Column from '@components/Column';
import Text from '@components/Text';
import styled from '@emotion/styled';
import useAppCustom from '@hooks/useAppCustom';
import { Fragment } from 'react';

import useMainRecommendedItems from './hooks/useMainRecommendedItems';
import RecommendationItem from './RecommendationItem';

function Recommendation() {
    const { useRecommend } = useAppCustom().main;
    const data = useMainRecommendedItems();
    if (!data || data.items.length === 0) {
        return (<Fragment/>);
    }
    if (useRecommend) {
        return (
            <Container as='section'>
                <TitleWrapper>
                    <Text size='xl' fontWeight='bold'>{data?.title}</Text>
                </TitleWrapper>
                <Contents >
                    {data?.items.map((item) => (
                        <RecommendationItem item={item}
                            key={item.itemId} />
                    ))}
                </Contents>
            </Container>
        );
    }
    return (<Fragment/>);
}

const Container = styled(Column)`
    padding: 16px 0 75px;
`;

const TitleWrapper = styled.div`
    padding: 0 20px;
`;

const Contents = styled.div`
    column-gap: 20px;
    display: flex;
    padding: 14px 20px 0;
    scroll-padding: 0 20px;
    width: 100%;
    overflow-x: auto;

    &::-webkit-scrollbar {
        display: none;
    }
`;

export default Recommendation;
